import { connect } from 'react-redux'

import { EditMenuItemModal } from '@components/chef/edit'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state) => {
  const { copyMenuItemModal, editMenuItem, editMenuItemModal, chef, user } =
    state

  const { chefType } = chef
  const { show } = editMenuItemModal
  const errors = state.errors.menuItemModal || {}

  return {
    isCopy: copyMenuItemModal.show,
    errors,
    menuItem: editMenuItem,
    show,
    chefType,
    user,
  }
}

const mapDispatchToProps = () => {
  const { ChefService, OrderService, RestService, SettingsService, UIService } =
    services
  const {
    pStateToReduxMenuItem,
    pDefaultChildMenuFields,
    pToMenuItemVerifications,
    pDefaultComposedAltItemFields,
  } = presenters
  const {
    pGetRelatedChefMenuItemIds,
    pRequestSettings,
    pResponseMenuItem,
    pResponseMenuItems,
    pSerializeLoadMenuItemsParams,
    pResponseSettings,
    pRequestComposedAltChefMenuItem,
    pRequestUpdateMarketplaceAddOn,
    pRequestUpdateMenuItem,
    pRequestUpdateItemImages,
    pResponseChefs,
    pResponseChefMenuItemWithActiveMods,
    pResponseIndexMenuItems,
  } = presenters.Api
  const {
    CloseChildMenuItemModal,
    DeleteMenuItem,
    DeleteChildMenuItem,
    EditChildMenuItem,
    EditMenuItem,
    LoadChefMenuItems,
    LoadSettings,
    NewChildMenuItem,
    UpsertComposedMenuItem,
    DraftComposedAlternativeMenuItem,
    RetryOnTimeout,
    SaveMenuItem,
    SearchMenuItems,
    LoadChefs,
    LoadGroupOrderAddOnItems,
    RestoreMenuItem,
    GetChefMenuItem,
    CreateChefMenuItem,
    EditChefMenuItem,
    UpdateMenuItemHasMods,
  } = coordinators

  const { close } = UIService.EditMenuItem
  const {
    calculatePrice: calculateMarketPrice,
    calculateChefPrice,
    calculateChefPriceFromRetail,
  } = OrderService
  const clearErrors = UIService.Errors.clear
  const { displayWarningMessage, displaySuccessMessage } =
    UIService.FlashMessage
  const editChildMenuItem = EditChildMenuItem({
    ChefService,
    RestService,
    UIService,
    pResponseMenuItem,
  })
  const newChildMenuItem = NewChildMenuItem({
    ChefService,
    UIService,
    pDefaultChildMenuFields,
  })
  const saveMenuItem = SaveMenuItem({
    ChefService,
    RestService,
    UIService,
    pRequestComposedAltChefMenuItem,
    pRequestUpdateMarketplaceAddOn,
    pRequestUpdateMenuItem,
    pRequestUpdateItemImages,
    pResponseMenuItem,
    pResponseMenuItems,
    pSerializeLoadMenuItemsParams,
    CloseChildMenuItemModal,
    EditMenuItem,
    HandleError,
    pStateToReduxMenuItem,
  })
  const deleteMenuItem = DeleteMenuItem({
    ChefService,
    RestService,
    UIService,
    pResponseMenuItems,
    LoadChefMenuItems,
    pSerializeLoadMenuItemsParams,
    HandleError,
  })
  const deleteChildMenuItem = DeleteChildMenuItem({
    RestService,
    UIService,
    HandleError,
  })
  const loadMenuItemSettings = LoadSettings({
    RestService,
    SettingsService,
    pRequestSettings,
    pResponseSettings,
    RetryOnTimeout,
    HandleError,
  })('menuItems')
  const displayAlert = ({ message, title, options }) =>
    UIService.Alert.showPopup({ message, title, options })
  const loadChefs = LoadChefs({ ChefService, RestService, pResponseChefs })
  const loadGroupOrderAddOnItems = LoadGroupOrderAddOnItems({
    RestService,
    pResponseMenuItems: (json) => json.map((i) => pResponseMenuItem(i)),
  })
  const restoreMenuItem = RestoreMenuItem({
    ChefService,
    RestService,
    UIService,
    pResponseMenuItems,
    LoadChefMenuItems,
    pSerializeLoadMenuItemsParams,
    HandleError,
  })
  const { ConfirmationModal, InfoModal } = UIService
  const showCustomModal = InfoModal.displayInfoModal
  const getChefMenuItem = GetChefMenuItem({
    RestService,
    HandleError,
    pGetRelatedChefMenuItemIds,
    pResponseChefMenuItem: pResponseChefMenuItemWithActiveMods,
  })
  const createChefMenuItem = CreateChefMenuItem({
    RestService,
    HandleError,
    pResponseChefMenuItem: pResponseChefMenuItemWithActiveMods,
  })
  const editChefMenuItem = EditChefMenuItem({
    RestService,
    HandleError,
    pGetRelatedChefMenuItemIds,
    pResponseChefMenuItem: pResponseChefMenuItemWithActiveMods,
  })
  const updateMenuItemHasMods = UpdateMenuItemHasMods({
    RestService,
    HandleError,
  })

  const draftComposedAltMenuItem = DraftComposedAlternativeMenuItem({
    ChefService,
    UIService,
    pDefaultComposedAltItemFields,
  })

  const upsertComposedMenuItem = UpsertComposedMenuItem({
    RestService,
    ChefService,
    UIService,
    pGetRelatedChefMenuItemIds,
    pRequestComposedAltChefMenuItem,
    pResponseChefMenuItem: pResponseChefMenuItemWithActiveMods,
    HandleError,
  })

  const searchMenuItems = SearchMenuItems({
    RestService,
    pResponseMenuItemsSearch: pResponseIndexMenuItems,
  })

  return {
    calculateChefPrice,
    calculateMarketPrice,
    calculateChefPriceFromRetail,
    clearErrors,
    close,
    confirmationModal: ConfirmationModal,
    upsertComposedMenuItem,
    draftComposedAltMenuItem,
    deleteMenuItem,
    deleteChildMenuItem,
    displayAlert,
    editChildMenuItem,
    displayWarningMessage,
    displaySuccessMessage,
    loadMenuItemSettings,
    newChildMenuItem,
    saveMenuItem,
    searchMenuItems,
    loadChefs,
    loadGroupOrderAddOnItems,
    pToMenuItemVerifications,
    restoreMenuItem,
    showCustomModal,
    getChefMenuItem,
    createChefMenuItem,
    editChefMenuItem,
    updateMenuItemHasMods,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMenuItemModal)
